import React, { Component } from 'react';
declare var $;

class FormDatePickerSimple extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    componentDidMount() {
        var _this = this;

        this.$el = $(this.el);
        this.$el.datepicker({
            changeMonth: true,
            changeYear: true,
            yearRange: 'c-70:c+10',
            showOtherMonths: true,
            selectOtherMonths: true,
            afterShow: function() {
                $("#ui-datepicker-div, #ui-datepicker-div *[class^='ui-']").each(function(i, elm ) {
                    var css = elm.className.split(/\s+/);
                    for (var iCss = 0; iCss < css.length; iCss++) {
                        if (css[iCss].match("^ui-")) {
                            $(elm).addClass("datetime-" + css[iCss]);
                        }
                    }
                });                                     
            },
            onSelect: function() {
                var e = {
                    target: this
                }
                _this.onChange(e)
            }
        }).next(".ui-datepicker-trigger").addClass("icon-only btn-icon btn");
    }

    componentWillUnmount() {
        this.$el.datepicker('destroy');
    }     

    onChange(e) {
        this.props.onChange(e);
    }

    onKeyPress(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            
            if (this.props.onEnter == null) {
                return;
            }
            this.props.onEnter(e);
        }
    }

    render() {        
        return (
            <input type="text" ref={el => this.el = el} id={this.props.id} autoComplete="no-autocomplete" maxLength={this.props.maxlength} className="form-control CalendarTextBox" onChange={this.onChange} onKeyPress={this.onKeyPress} value={this.props.value} />
        );
    }
}

export default FormDatePickerSimple;


// WEBPACK FOOTER //
// ./src/Fields/FormDatePickerSimple.js